// recoil
import { atom } from 'recoil';

const localStorageEffect =
    (key, defaultObject) =>
    ({ setSelf, onSet, trigger }) => {
        const loadLocalStorage = () => {
            const value = localStorage.getItem(key);
            if (value != null) {
                setSelf(JSON.parse(value));
            }
        };

        if (trigger === 'get') {
            loadLocalStorage();
        }

        onSet((newValue, oldValue, isReset) => {
            if (isReset) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key, JSON.stringify(newValue));
            }
        });
    };

const LocalStorageDefault = {
    config: {
        data: null,
        meta: {
            hash: '',
            updatedAt: 0,
        },
    },
};

const LocalStorageState = atom({
    key: 'LocalStorageState',
    default: LocalStorageDefault,
    effects: [localStorageEffect(process.env.LOCAL_STORAGE_NAME)],
});

export { LocalStorageState };
